import { NavLink } from 'react-router-dom';
import { IconBolt, IconHome, IconLeaf, IconMoon, IconPulse } from './icons';

const TABS = [
  { to: '/', label: 'Hoy', icon: IconHome, end: true },
  { to: '/sueno', label: 'Sueno', icon: IconMoon, end: false },
  { to: '/recuperacion', label: 'Recuperacion', icon: IconPulse, end: false },
  { to: '/actividad', label: 'Actividad', icon: IconBolt, end: false },
  { to: '/nutricion', label: 'Nutricion', icon: IconLeaf, end: false },
];

export function BottomNav() {
  return (
    <nav className="bottom-nav">
      {TABS.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => `bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`}
        >
          <Icon size={22} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
